import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12 mt-3 mb-3 text-center" }
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = { class: "bg-white p-3 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, "评论区", -1)
const _hoisted_9 = { class: "row mt-3 mb-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-12" }
const _hoisted_12 = { class: "bg-white p-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", null, "推荐媒体/自媒体", -1)
const _hoisted_14 = { class: "media-box-holder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticleListItem = _resolveComponent("ArticleListItem")!
  const _component_ElPagination = _resolveComponent("ElPagination")!
  const _component_CommentList = _resolveComponent("CommentList")!
  const _component_AlbumItem = _resolveComponent("AlbumItem")!
  const _component_Media = _resolveComponent("Media")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article_info) => {
          return (_openBlock(), _createBlock(_component_ArticleListItem, {
            key: article_info._id,
            class: "col-md-4 col-sm-6 col-xs-12 col-12",
            article: article_info,
            full: 2,
            position: "related"
          }, null, 8, ["article"]))
        }), 128)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_ElPagination, {
            layout: "total,prev, pager, next",
            total: _ctx.pagination.total > 120 ? 240 : _ctx.pagination.total,
            "page-size": 20,
            background: "",
            onCurrentChange: _ctx.handlePageChange
          }, null, 8, ["total", "onCurrentChange"])
        ])
      ])), [
        [_directive_loading, _ctx.articleLoading]
      ]),
      (_ctx.userInfo.userId)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_CommentList, {
                  "target-type": "ALL",
                  "target-id": '',
                  "comment-info": {}
                })
              ])
            ])
          ])), [
            [_directive_loading, _ctx.albumLoading]
          ])
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albums, (album) => {
          return (_openBlock(), _createBlock(_component_AlbumItem, {
            key: album._id,
            album: album,
            class: "col-md-2 col-sm-4 col-xs-12 col-12"
          }, null, 8, ["album"]))
        }), 128))
      ])), [
        [_directive_loading, _ctx.albumLoading]
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medias, (media_info) => {
                return (_openBlock(), _createBlock(_component_Media, {
                  key: media_info._id,
                  "media-info": media_info
                }, null, 8, ["media-info"]))
              }), 128))
            ])
          ])), [
            [_directive_loading, _ctx.mediaLoading]
          ])
        ])
      ])
    ])
  ]))
}